const isExtensionNoise = (message, filename, stack) => {
  const text = [message, filename, stack].filter(Boolean).join(" ");
  return (
    /chrome-extension:\/\//i.test(text) ||
    /Failed to connect to MetaMask/i.test(text) ||
    /MetaMask/i.test(text)
  );
};

window.addEventListener(
  "error",
  (event) => {
    if (
      isExtensionNoise(
        event.message,
        event.filename,
        event.error && event.error.stack,
      )
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    const message = reason && reason.message ? reason.message : reason;
    const stack = reason && reason.stack ? reason.stack : "";
    if (isExtensionNoise(message, "", stack)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);
